import styled from 'styled-components';
import Collapse from 'components/collapse/Collapse';
import CommonTable from 'components/table/CommonTable';
import { DisplayPreArrivalFormField } from '../../PreArrivalFormTab.types';

export const CollapseSectionStyled = styled(Collapse)`
  &:not(:last-child) {
    margin-bottom: 40px;
  }

  .table {
    margin-bottom: 0;
  }
`;

export const SectionTableStyled = styled(
  CommonTable<DisplayPreArrivalFormField>,
)`
  .column-status {
    width: 32px;
  }

  .checkbox {
    margin: 0;
  }

  .body-cell-fieldValidation {
    .form-group > div > div {
      flex-direction: row;
      margin: 0;
    }
  }
`;
